import type { QuickSearchRegistryResult } from '@/components/quick-search/quick-search-types';
import type { QuickSearchResult } from '@/components/quick-search/quick-search-types';

export function getQuickSearchResultCommandValue(
  result: QuickSearchResult | QuickSearchRegistryResult,
): string {
  return result.id;
}

export function resolveFirstVisibleQuickSearchResult(
  groupOrder: readonly string[],
  grouped: Map<string, QuickSearchResult[]>,
): QuickSearchResult | undefined {
  for (const group of groupOrder) {
    const items = grouped.get(group);
    if (items?.length) return items[0];
  }
  return undefined;
}

/** After query change — always reset manual navigation and select the first visible row. */
export function resolveSelectionAfterQueryChange(firstVisibleValue: string): string {
  return firstVisibleValue;
}

/**
 * After merged results reorder (e.g. server entities arrive).
 * Keeps the current selection when the user already moved with keyboard or pointer.
 */
export function resolveSelectionAfterResultsChange(
  userNavigated: boolean,
  firstVisibleValue: string,
  currentActiveValue: string,
): string {
  if (userNavigated) return currentActiveValue;
  return firstVisibleValue;
}
